// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        suggestionMobileStyle: 'style1'
    }
};

// Override Settings
(function () {  // Add this
  BoostPFS.inject(this);  // Add this

  InstantSearchResultItemCollection.prototype.compileTemplate = function() {
    return this.getTemplate()
				.replace(/{{class.searchSuggestionItem}}/g, 'boost-pfs-search-suggestion-item hidden')
				.replace(/{{class.searchUiAutocompleteItem}}/g, 'boost-pfs-ui-item')
				.replace(/{{escapedBlockType}}/g, 'collections')
				.replace(/{{escapedDataTitle}}/g, this.data.title)
				.replace(/{{searchLink}}/g, '/collections/' + this.data.handle)
				.replace(/{{highlightedSuggestionResult}}/g, `<collection-count data-handle="${this.data.handle}" data-collection-id="${this.data.id}">${this.data.title}</collection-count>`);
  };

  InstantSearchResultItemProduct.prototype.compileTemplate = function() {

    if (this.isShow) {
			var searchTerm = Utils.escape(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
      
      var itemNameMetafield = this.data.metafields && Array.isArray(this.data.metafields)
        ? this.data.metafields.find(function(m) { return m && m.value && String(m.value).includes('IMP_ItemName'); })
        : undefined;

      if (itemNameMetafield) {
        try {
          let metafieldJsonValue = JSON.parse(itemNameMetafield.value);
          if (metafieldJsonValue.content.hasOwnProperty(Shopify.locale)) {
            let metafieldProductTitle = metafieldJsonValue.content[Shopify.locale];
            if (metafieldProductTitle.toLowerCase().includes('<p>')) {
              var parser = new DOMParser();
              var htmlTitle = parser.parseFromString(metafieldProductTitle, 'text/html');
              productTitle = htmlTitle.querySelector('p').innerText;
            }
            else {
              productTitle = metafieldJsonValue.content[Shopify.locale];
            }
          }
        } catch(err) {}
      }
      
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
        skuHTML = skuHTML.replace(/SKU:/g, 'REF:');
			}
			// Vendor
			var vendorHTML = '';
			// if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
			// 	vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
			// 	vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			// }
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

      var itemPriceHTML = priceHTML;
      var metafield = this.data.metafields && this.data.metafields.find(function(m) { return m.key === 'ItemNumber'; });
      if (metafield && metafield.value) {
        try {
          var parsed = JSON.parse(metafield.value);
          if (parsed && parsed.content && parsed.content.xx && parsed.key) {
            var xx = parsed.content.xx;
            var company = parsed.key.split('_')[0];
            var moneyFormat = (document.body && document.body.dataset && document.body.dataset.money_format) ? document.body.dataset.money_format : '';
            itemPriceHTML = '<product-price class="product-price" data-item_id="' + xx + '" data-company="' + company + '" data-money_format="' + moneyFormat + '">' + (window.languages && window.languages.loadingPrice ? window.languages.loadingPrice : 'Loading price...') + '</product-price>';
          }
        } catch (e) {}
      }

			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.escape(this.parent.type))
				.replace(/{{url}}/g, this.url)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, productTitle)
				.replace(/{{escapedTitle}}/g, Utils.escape(productTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, itemPriceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
		} else {
			return '';
		}

  }


  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {  
  };

  // BoostPFS.prototype.buildSearchResultHeader = function(data){
  // 	jQ('.boost-pfs-filter-breadcrumb').each(function(index, breadcrumb) {
  // 		var html = jQ(breadcrumb).html();
  // 		html = html.replace(/{{terms}}/, Globals.queryParams.q)
  // 		jQ(breadcrumb).html(html);
  // 		jQ(breadcrumb).removeClass('hidden');
  // 	})	
  // };

  // InstantSearch.prototype.beforeInit = function (id) {
  // 	if (Settings.getSettingValue('search.enableSuggestion')) {

  // 		//Remove theme's instant search
  // 		removeThemeSearchEvent();

  // 		var self = this;
  // 		if (typeof id === 'undefined') {
  // 			jQ('input[name="' + this.searchTermKey + '"]').each(function (i) {
  // 				if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
  // 					var id = 'boost-pfs-search-box-' + i;
  // 					jQ(this).attr('id', id);
  // 					self.buildSearchBox('#' + id)
  // 				}
  // 			});
  // 		} else {
  // 			this.buildSearchBox(id);
  // 		}
  // 		if (this.isMobile()) {
  // 			// Clear cache when going back from another page
  // 			window.onpageshow = function (event) {
  // 				if (event.persisted) {
  // 					window.location.reload();
  // 				}
  // 			};
  // 			// Build Suggestion mobile on top
  // 			if (Settings.getSettingValue('search.suggestionMobileStyle') == 'style1') {
  // 				this.buildSuggestionMobile();
  // 			}
  // 		}
  // 	}
  // };

  // function removeThemeSearchEvent() {
  // 	// Remove all events
  // 	if (jQ('.header__search-bar-wrapper').length > 0) {
  // 		var cloneSearchBar = jQ('.header__search-bar-wrapper:first').clone();
  // 		jQ('.header__search-bar-wrapper').replaceWith(cloneSearchBar);
  // 		jQ('.search-bar__filter').hide();
  // 	}
  // 	// Rebuild some event
  // 	if (jQ('[data-action="toggle-search"]').length > 0) {
  // 		jQ('[data-action="toggle-search"]').on('click', function () {
  // 			jQ('.header__search-bar-wrapper').toggleClass('is-visible');
  // 		})
  // 	}
  // 	if (jQ('[data-action="clear-input"]').length > 0) {
  // 		jQ('[data-action="clear-input"]').on('click', function () {
  // 			jQ('input[name="' + bcsffilter.searchTermKey + '"]').val('');
  // 		})
  // 	}
  // }
  
 var bindEvents = InstantSearchMobile.prototype.bindEvents;

  InstantSearchMobile.prototype.bindEvents = function() {
      bindEvents.call(this);

      var self = this;

      jQ('.header__action-item-link[data-action="toggle-search"]').off('click').click(function(e) {
        e.preventDefault();
        //e.stopPropagation();
        jQ('.search-bar__input').focus();
        self.openSuggestionMobile();

      });

  }
  
  var originalcloseInstantSearchMobile = InstantSearchMobile.prototype.closeInstantSearchMobile;
    InstantSearchMobile.prototype.closeInstantSearchMobile = function(isClose) {
          // Call the original function in our app lib.
          // We don't have to copy a very big function out here to modify.
          // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
          originalcloseInstantSearchMobile.call(this,isClose);

          // Do your custom code after the original function has run

        jQ('.header__search-bar-wrapper').removeClass('is-visible');


    }
  
    InstantSearchApi.beforeCall = function(searchTerm) {
        /* Change the params before calling api */
        /** 
         * Search terms containing a , have not been executed
         * https://trello.com/c/8kXEh05K/143-suche-funktioniert-nicht
         * */
      	//var newSearchTerm = searchTerm.replace('/%2C/g','.');
        //Globals.instantSearchQueryParams['q'] = newSearchTerm;
    }

})();  // Add this at the end